import React from 'react';
import Error from '../system/Error.react.js';
import {ParentBox, relayWrap} from "../../box-utils/ParentBox.react";
import PropTypes from "prop-types";
import {handlerName} from "./edit/JSActionEdit.react";
import BoxDecorator from '../../box-utils/BoxDecorator.react';
import LoadingButtonNew from '../../../fw/LoadingButtonNew.react';
import {displayError, sendError} from "../../../app/errorDisplayer";
import {defineMessages, IntlShape} from 'react-intl';
import InvokeChannelActionMutation from "../../../channels/InvokeChannelActionMutation.react";
import mutationError from "../../../channel-defs/mutationError";
import {safeJSONparse} from "../../../../common/util/safeJSONparse";
import {viewWithDataGetPrimaryData} from "../../box-utils/PrimaryData";

const messages = defineMessages({
    errorUnknown: {id: 'invokeChannelAction.errorUnknown', 'defaultMessage': 'Unknown error during action'},
    errorDescription: {id: 'invokeChannelAction.errorDescription', 'defaultMessage': 'Error during action: {errorMessage}'},
});

class JSAction extends ParentBox {

    static handlerName = handlerName;

    static propTypes = {
        isPreview: PropTypes.bool,
        viewWithData: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);

        this.state = {
            isSending: false
        };
    }

    getIcon() {
        return "dativery";
    }

    getServiceName() {
        return "Dativery";
    }

    performAction() {

        this.setState({
            isSending: true
        });

        let promise = new Promise((resolve, reject) => {
            let onSuccess = ({invokeChannelAction}) => {
                if (invokeChannelAction.success) {
                    this.setState({
                        isSending: false
                    });
                } else {
                    let message = invokeChannelAction.message
                        ? this.props.intl.formatMessage(messages.errorDescription, {errorMessage: invokeChannelAction.message})
                        : this.props.intl.formatMessage(messages.errorUnknown);

                    let self = this;
                    displayError(message).then(() => {
                        self.setState({
                            isSending: false
                        });
                    }).catch((e) => {
                        sendError(e);
                    });
                }
                resolve();
            };

            let onFailure = (transaction) => {
                let error = mutationError(transaction, false);
                let self = this;
                displayError(error).then(() => {
                    self.setState({
                        isSending: false
                    });
                }).catch((e) => {
                    /* ignore error */
                });

                reject(error);
            };

            let channelAddon = this.props.viewWithData.view.channelAddon;
            let addonId = null;
            let addonDefId = null;
            if (channelAddon) {
                addonId = channelAddon.realId;
                addonDefId = channelAddon.addonDef.realId;
                let options = channelAddon.options;
                if (options) {
                    options = safeJSONparse(options);
                }
            }
            let args = {
                addon_id: addonId,
                addonDef_id: addonDefId,
                data: viewWithDataGetPrimaryData(this.props.viewWithData),
            };

            let mutationArgs = {
                channel: this.props.viewWithData.view.channelAddon ? this.props.viewWithData.view.channelAddon.channel : null,
                connectedChannel: this.props.viewWithData.view.connectedChannel,
                channelDefId: this.props.viewWithData.data[0]['channelDefId'],
                channelEntityDefId: this.props.viewWithData.data[0]['channelEntityDefId'],
                entityDef: this.props.viewWithData.entityDef,
                actionName: 'js-action',
                args: args,
            };

            if (this.props.relay) {
                this.props.relay.commitUpdate(
                    new InvokeChannelActionMutation(mutationArgs), {onSuccess: onSuccess, onFailure: onFailure}
                );
            }
        });
        return promise;
    }

    render() {

        let addonOptions = {};
        let channelAddon = this.props.viewWithData.view.channelAddon;
        if (channelAddon && channelAddon.options) {
            addonOptions = this.props.viewWithData.view.channelAddon.options;
            addonOptions = safeJSONparse(addonOptions);
        }

        try {
            return (
                <BoxDecorator icon={this.getIcon()} isPreview={this.props.isPreview} title={this.getServiceName()}>
                    <div style={{padding: '5px'}}>
                        <LoadingButtonNew
                            className="btn btn-default"
                            horizontal
                            icon={channelAddon && addonOptions ? addonOptions.icon : "fa-times"}
                            onClick={this.performAction.bind(this)}
                            progressText={channelAddon && addonOptions && addonOptions.running ? addonOptions.running : "Running..."}
                            text={channelAddon ? (addonOptions ? addonOptions.name : (channelAddon.name ? channelAddon.name : channelAddon.addonDef.name)) : "Running..."}
                            type='button'
                            withoutDone
                        />
                    </div>
                </BoxDecorator>
            );
        } catch (e) {
            sendError(e);
            return (<Error error={e} />);
        }
    }
}

export default relayWrap(JSAction);
